// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Employee create form sections (Stitch: New employee) ——— */
.employee-form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.employee-form__section {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
}

.employee-form__section-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  margin-bottom: 14px;
  border-bottom: 1px solid #E2E8F0;
  min-width: 0;
}

.employee-form__section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0EA5E9;
  flex-shrink: 0;
}

.employee-form__optional {
  color: #64748B;
  font-weight: 500;
}

.employee-form__help {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #64748B;
}

.employee-form__section-title {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #0F172A;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.3;
}

.employee-form__grid {
  display: grid;
  gap: 14px 20px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.employee-form__grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.employee-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.employee-form__field--full {
  grid-column: 1 / -1;
}

.employee-form__label {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  line-height: 1.3;
}

.employee-form__req {
  color: #F43F5E;
}

.employee-form .ant-form-item {
  margin-bottom: 0 !important;
  line-height: normal !important;
  font-size: 12px !important;
}

.employee-form .ant-form-item-label {
  display: none;
  padding: 0 !important;
}

.employee-form .ant-form-item-control-input {
  min-height: 36px !important;
}

.employee-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

.employee-form .ant-form-item-control,
.employee-form .ant-form-item-control-input,
.employee-form .ant-form-item-control-input-content {
  max-width: 100%;
  min-width: 0;
}

.employee-form .ant-select,
.employee-form .ant-picker,
.employee-form .ant-input-affix-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

.employee-form .ant-input-affix-wrapper,
.employee-form .ant-input-affix-wrapper-lg,
.employee-form .ant-picker,
.employee-form .ant-select-selector {
  box-sizing: border-box !important;
  height: 36px !important;
  min-height: 36px !important;
  border-radius: 8px !important;
  border: 1px solid #E2E8F0 !important;
  font-size: 13px !important;
  color: #0F172A !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
  background: #fff !important;
}

.employee-form .ant-input-affix-wrapper,
.employee-form .ant-input-affix-wrapper-lg {
  padding: 0 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  width: 100%;
}

.employee-form .ant-form-item-control-input-content > input.ant-input:not(textarea) {
  box-sizing: border-box !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 !important;
  padding: 6px 12px !important;
  border-radius: 8px !important;
  border: 1px solid #E2E8F0 !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #0F172A !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
  background: #fff !important;
}

.employee-form .ant-input-affix-wrapper input.ant-input,
.employee-form .ant-input-affix-wrapper-lg input.ant-input {
  box-sizing: border-box !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #0F172A !important;
}

.employee-form .ant-picker {
  width: 100%;
  padding: 0 11px !important;
  display: flex !important;
  align-items: center !important;
}

.employee-form .ant-picker-input {
  display: flex !important;
  align-items: center !important;
  width: 100%;
  height: 100%;
}

.employee-form .ant-picker-input > input {
  font-size: 13px !important;
  line-height: 1.5 !important;
  height: auto !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.employee-form input.ant-input::placeholder,
.employee-form .ant-picker-input > input::placeholder {
  color: #94A3B8 !important;
  opacity: 1 !important;
}

.employee-form .ant-select-selection-item,
.employee-form .ant-select-selection-placeholder {
  line-height: 34px !important;
  display: flex !important;
  align-items: center !important;
  font-size: 13px !important;
}

.employee-form .ant-select-single .ant-select-selector {
  display: flex !important;
  align-items: center;
  padding-inline: 11px !important;
}

.employee-form .ant-form-item-feedback-icon {
  display: none !important;
}

.employee-form .ant-input-password .ant-input-suffix {
  display: inline-flex !important;
  align-items: center !important;
  color: #94A3B8;
}

.employee-form .ant-form-item-control-input-content > input.ant-input:not(textarea):hover,
.employee-form .ant-input-affix-wrapper:hover,
.employee-form .ant-picker:hover,
.employee-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #94A3B8 !important;
}

.employee-form .ant-form-item-control-input-content > input.ant-input:not(textarea):focus,
.employee-form .ant-input-affix-wrapper-focused,
.employee-form .ant-input-affix-wrapper:focus-within,
.employee-form .ant-picker-focused,
.employee-form .ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.employee-form .ant-input-affix-wrapper input.ant-input:focus {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

@media (max-width: 900px) {
  .employee-form__grid--3 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/employees/style.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;;EAIE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;EACzB,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;;EAKE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ——— Employee create form sections (Stitch: New employee) ——— */\n.employee-form {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.employee-form__section {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n}\n\n.employee-form__section-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 8px;\n  margin-bottom: 14px;\n  border-bottom: 1px solid #E2E8F0;\n  min-width: 0;\n}\n\n.employee-form__section-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.employee-form__optional {\n  color: #64748B;\n  font-weight: 500;\n}\n\n.employee-form__help {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #64748B;\n}\n\n.employee-form__section-title {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0F172A;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  line-height: 1.3;\n}\n\n.employee-form__grid {\n  display: grid;\n  gap: 14px 20px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.employee-form__grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.employee-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.employee-form__field--full {\n  grid-column: 1 / -1;\n}\n\n.employee-form__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.employee-form__req {\n  color: #F43F5E;\n}\n\n.employee-form .ant-form-item {\n  margin-bottom: 0 !important;\n  line-height: normal !important;\n  font-size: 12px !important;\n}\n\n.employee-form .ant-form-item-label {\n  display: none;\n  padding: 0 !important;\n}\n\n.employee-form .ant-form-item-control-input {\n  min-height: 36px !important;\n}\n\n.employee-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.employee-form .ant-form-item-control,\n.employee-form .ant-form-item-control-input,\n.employee-form .ant-form-item-control-input-content {\n  max-width: 100%;\n  min-width: 0;\n}\n\n.employee-form .ant-select,\n.employee-form .ant-picker,\n.employee-form .ant-input-affix-wrapper {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n\n.employee-form .ant-input-affix-wrapper,\n.employee-form .ant-input-affix-wrapper-lg,\n.employee-form .ant-picker,\n.employee-form .ant-select-selector {\n  box-sizing: border-box !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  border-radius: 8px !important;\n  border: 1px solid #E2E8F0 !important;\n  font-size: 13px !important;\n  color: #0F172A !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;\n  background: #fff !important;\n}\n\n.employee-form .ant-input-affix-wrapper,\n.employee-form .ant-input-affix-wrapper-lg {\n  padding: 0 12px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  width: 100%;\n}\n\n.employee-form .ant-form-item-control-input-content > input.ant-input:not(textarea) {\n  box-sizing: border-box !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0 !important;\n  padding: 6px 12px !important;\n  border-radius: 8px !important;\n  border: 1px solid #E2E8F0 !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n  color: #0F172A !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;\n  background: #fff !important;\n}\n\n.employee-form .ant-input-affix-wrapper input.ant-input,\n.employee-form .ant-input-affix-wrapper-lg input.ant-input {\n  box-sizing: border-box !important;\n  height: 100% !important;\n  min-height: 0 !important;\n  max-height: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n  color: #0F172A !important;\n}\n\n.employee-form .ant-picker {\n  width: 100%;\n  padding: 0 11px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.employee-form .ant-picker-input {\n  display: flex !important;\n  align-items: center !important;\n  width: 100%;\n  height: 100%;\n}\n\n.employee-form .ant-picker-input > input {\n  font-size: 13px !important;\n  line-height: 1.5 !important;\n  height: auto !important;\n  padding: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.employee-form input.ant-input::placeholder,\n.employee-form .ant-picker-input > input::placeholder {\n  color: #94A3B8 !important;\n  opacity: 1 !important;\n}\n\n.employee-form .ant-select-selection-item,\n.employee-form .ant-select-selection-placeholder {\n  line-height: 34px !important;\n  display: flex !important;\n  align-items: center !important;\n  font-size: 13px !important;\n}\n\n.employee-form .ant-select-single .ant-select-selector {\n  display: flex !important;\n  align-items: center;\n  padding-inline: 11px !important;\n}\n\n.employee-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.employee-form .ant-input-password .ant-input-suffix {\n  display: inline-flex !important;\n  align-items: center !important;\n  color: #94A3B8;\n}\n\n.employee-form .ant-form-item-control-input-content > input.ant-input:not(textarea):hover,\n.employee-form .ant-input-affix-wrapper:hover,\n.employee-form .ant-picker:hover,\n.employee-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n  border-color: #94A3B8 !important;\n}\n\n.employee-form .ant-form-item-control-input-content > input.ant-input:not(textarea):focus,\n.employee-form .ant-input-affix-wrapper-focused,\n.employee-form .ant-input-affix-wrapper:focus-within,\n.employee-form .ant-picker-focused,\n.employee-form .ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.employee-form .ant-input-affix-wrapper input.ant-input:focus {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n@media (max-width: 900px) {\n  .employee-form__grid--3 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
